// extracted by mini-css-extract-plugin
module.exports = {"rotation":"FormResendActivation_rotation__GEHWN"};